import { type FocusEvent, useState } from 'react';

export const useFieldErrors = (showAllErrors: boolean) => {
  const [blurredFields, setBlurredFields] = useState<ReadonlySet<string>>(() => new Set());

  const shouldShowError = (field: string): boolean => showAllErrors || blurredFields.has(field);
  const markBlurred = (field: string) => {
    setBlurredFields((fields) => (fields.has(field) ? fields : new Set(fields).add(field)));
  };
  const onBlur = (field: string) => (event: FocusEvent<HTMLElement>) => {
    // Moving between a radio group's options stays within the field.
    if (event.currentTarget.contains(event.relatedTarget)) return;
    markBlurred(field);
  };

  return { shouldShowError, onBlur, markBlurred };
};
